// Central API base URL.
// Production: Nginx proxies /api/ to uvicorn and strips the prefix,
// so the frontend calls relative /api and never needs to know the
// server's internal address.
// Local dev: no Nginx in front of the dev server, so we call the
// backend directly on its port.
export const API_BASE = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';